import styled from "styled-components";

export const Container = styled.div`
    display: ${props =>(props.$invisible ? 'none' : 'flex')};
    position: relative;
    flex-direction: column;
    width: 250px;
    padding: 15px;
    height: 280px;
    background: ${props =>(props.$active ? '#F6F6F6' : 'transparent')};
    border-radius: 15.898px;
    border: ${props =>('2px solid ' + props.color)};
    user-select: none;
    outline: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -webkit-tap-highlight-color: transparent;
    cursor: pointer;
    box-shadow: -1px 1px 11px 0 rgba(0, 0, 0, 0.25) inset;
    @media (min-width: 768px) {
        height: 340px;
        padding: 20px;
        min-width: 258px;
        width: 100%;
    }
    @media (orientation: landscape) and (max-width: 1200px){
        height: 280px;
        padding: 15px;
        width: 45%;
        max-width: 250px;
        min-width: 230px;
    }
`;

export const Title = styled.h1`
    color: ${props =>(props.$active ? '#333' : '#333')};
    text-align: center;
    leading-trim: both;
    text-edge: cap;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 100%;
    padding-inline: 10px;
    height: 80px;
    background: transparent;
    @media (max-width: 768px) {
        font-size: 16px;
    }
    @media (orientation: landscape) and (max-width: 1200px){
        font-size: 20px;
    }
`;

export const ContainerChild = styled.div`
    display: flex;
    justify-content: space-between;
    height: 100%;
    width: 100%;
`;

export const ContainerRight = styled.div`
    display: flex;
    justify-content: flex-end;
    height: 100%;
    width: 100%;
`;

export const ContainerLeft = styled.div`
    display: flex;
    justify-content: flex-start;
    height: 100%;
    width: 100%;
`;

export const AlarmIndicator = styled.div`
    display: flex;
    position: absolute;
    top: 20px;
    right: 20px;
`;